module.exports = __webpack_public_path__ + "img/game-treasure-of-aztec.a5c2342b.png";